import React, { useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";

export default function TipLine() {
  const {
    currentStep
  } = useContext(CarOrderingContext)

  if (currentStep === null) {
    return null
  }

  if (typeof currentStep.tip !== 'string' || currentStep.tip.length < 1) {
    return null
  }

  return (
    <div className='tip'>
      <p>{currentStep.tip}</p>
    </div>
  )
}
